
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sell",
      function () {
        return require("private-next-pages/sell.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sell"])
      });
    }
  